import Content from './content';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import { Popup } from '@CS/components/Popups';
import ErrorContent from './NetworkError.styles';

type NetworkErrorProps = {
  onRetry?: () => void;
};

export const NetworkError = ({ onRetry }: NetworkErrorProps) => {
  const { title, text, button } = useTranslation(Content);

  return (
    <Popup fullScreen hideClose>
      <ErrorContent>
        <h2>{title}</h2>
        <span>{text}</span>
        <Button text={button} onClick={onRetry} />
      </ErrorContent>
    </Popup>
  );
};
